<!--
	日期：2025/09/25
	地点：四川 成都
	作者：终结司令官
	
	介绍：我的个人信息修改
	
	- Powered by finalcommander.com
	- Supported by IOE.TOP
-->
<template>
	<div id="app-myinfo" class="app-myinfo">

		<!-- 上传中 -->
		<el-dialog
		  title="上传中"
		  ref="Uploading"
		  :visible.sync="dialogVisibleUploading"
		  :before-close="Uploading_handleClose">
			<template v-if="filesOnUploading && filesOnUploading.length">
			  <div v-for="(item, index) in filesOnUploading" 
				:key="index">
				<span v-if="item && item.name">
					<i class="el-icon-loading"/> 
					<span style="font-weight:bold;padding-left:5px;">
						{{ item.name }} 
					</span>
					<span style="color:#d0d0d0;padding-left:10px;">
						{{ (fileOnUploading.size/1024/1024).toFixed(2) }} MB
					</span>
			    </span>
				<span v-if="fileOnUploading.name == item.name">
					<span style="color:#d0d0d0;padding-left:10px;">传输中 ...</span>
				</span>
			  </div>
			</template>
		</el-dialog>
		
		<!-- 补充信息登记 -->
		<el-dialog
		  title="信息登记"
		  ref="OtherInfo"
		  class="mydialog"
		  :visible.sync="dialogVisibleOtherInfo"
		  :before-close="handleClose">
		  <!-- 用户的表单信息 -->
			<el-form ref="modifyFormOtherInfo" :inline="true" :rules="rules" :model="otherInfo_cols">
			  <el-form-item label="身份证号" prop='idcard'>
				<el-input v-model="otherInfo_cols.idcard" class="input-item" placeholder="请输入 ..."></el-input>
			  </el-form-item>
			  <el-form-item label="家庭住址" prop='address'>
				<el-input v-model="otherInfo_cols.address" class="input-item" placeholder="请输入 ..."></el-input>
			  </el-form-item>
			  <el-form-item label="工作单位" prop='cop'>
				<el-input v-model="otherInfo_cols.cop" class="input-item" placeholder="请输入 ..."></el-input>
			  </el-form-item>
			  <el-form-item label="单位地址" prop='cop_address'>
				<el-input v-model="otherInfo_cols.cop_address" class="input-item" placeholder="请输入 ..."></el-input>
			  </el-form-item>
			  <el-form-item label="身份证复印件" prop='idcard_files'>
				<el-upload
				  class="upload-demo"
				  :action="get_IOETOP_BaseUrl() + '/open/api/2.0.1/upload/file/' + get_username_at()"
				  :on-preview="other_idcard_files_handleFilePreview"
				  :on-remove="other_idcard_files_handleFileRemove"
				  :on-success="other_idcard_files_handleFileSuccess"
				  :before-remove="other_idcard_files_beforeFileRemove"
				  :before-upload="other_idcard_files_beforeUpload"
				  multiple
				  :limit="5"
				  :on-exceed="other_idcard_files_handleFileExceed"
				  :file-list="otherInfo_cols.idcard_files">
				  <el-button size="small" type="primary">点击上传</el-button>
				  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb
				  </div>
				</el-upload>
			  </el-form-item>
			  <el-form-item label="备注" prop='remark'>
				<el-input 
					v-model="otherInfo_cols.remark" 
					class="inputtextarea-item" 
					type="textarea"
					:rows="5"
					placeholder="请输入文字"></el-input>
			  </el-form-item>
			  <el-form-item label="附件" prop='files'>
				<el-upload
				  class="upload-demo"
				  :action="get_IOETOP_BaseUrl() + '/open/api/2.0.1/upload/file/' + get_username_at()"
				  :on-preview="other_files_handleFilePreview"
				  :on-remove="other_files_handleFileRemove"
				  :on-success="other_files_handleFileSuccess"
				  :before-remove="other_files_beforeFileRemove"
				  :before-upload="other_files_beforeUpload"
				  multiple
				  :limit="5"
				  :on-exceed="other_files_handleFileExceed"
				  :file-list="otherInfo_cols.files">
				  <el-button size="small" type="primary">点击上传</el-button>
				  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb
				  </div>
				</el-upload>
			  </el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeForm('modifyFormOtherInfo')">关 闭</el-button>
				<el-button type="primary" @click="submitForm('modifyFormOtherInfo')">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 合伙人信息登记 -->
		<el-dialog
		  title="合伙人信息登记"
		  ref="partnerInfo"
		  class="mydialog"
		  :visible.sync="dialogVisiblePartnerInfo"
		  :before-close="handleClose">
		  <!-- 合伙人用户的表单信息 -->
			<el-form ref="modifyFormPartnerInfo" :inline="true" :rules="rules" :model="partnerInfo_cols">
			  <el-form-item label="身份证号" prop='idcard'>
				<el-input v-model="partnerInfo_cols.idcard" class="input-item" placeholder="请输入 ..."></el-input>
			  </el-form-item>
			  <el-form-item label="家庭住址" prop='address'>
				<el-input v-model="partnerInfo_cols.address" class="input-item" placeholder="请输入 ..."></el-input>
			  </el-form-item>
			  <el-form-item label="工作单位" prop='cop'>
				<el-input v-model="partnerInfo_cols.cop" class="input-item" placeholder="请输入 ..."></el-input>
			  </el-form-item>
			  <el-form-item label="单位地址" prop='cop_address'>
				<el-input v-model="partnerInfo_cols.cop_address" class="input-item" placeholder="请输入 ..."></el-input>
			  </el-form-item>
			  <el-form-item label="身份证复印件" prop='idcard_files'>
				<el-upload
				  class="upload-demo"
				  :action="get_IOETOP_BaseUrl() + '/open/api/2.0.1/upload/file/' + get_username_at()"
				  :on-preview="partner_idcard_files_handleFilePreview"
				  :on-remove="partner_idcard_files_handleFileRemove"
				  :on-success="partner_idcard_files_handleFileSuccess"
				  :before-remove="partner_idcard_files_beforeFileRemove"
				  :before-upload="partner_idcard_files_beforeUpload"
				  multiple
				  :limit="5"
				  :on-exceed="partner_idcard_files_handleFileExceed"
				  :file-list="partnerInfo_cols.idcard_files">
				  <el-button size="small" type="primary">点击上传</el-button>
				  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb
				  </div>
				</el-upload>
			  </el-form-item>
			  <el-form-item label="备注" prop='remark'>
				<el-input 
					v-model="partnerInfo_cols.remark" 
					class="inputtextarea-item" 
					type="textarea"
					:rows="5"
					placeholder="请输入文字"></el-input>
			  </el-form-item>
			  <el-form-item label="附件" prop='files'>
				<el-upload
				  class="upload-demo"
				  :action="get_IOETOP_BaseUrl() + '/open/api/2.0.1/upload/file/' + get_username_at()"
				  :on-preview="partner_files_handleFilePreview"
				  :on-remove="partner_files_handleFileRemove"
				  :on-success="partner_files_handleFileSuccess"
				  :before-remove="partner_files_beforeFileRemove"
				  :before-upload="partner_files_beforeUpload"
				  multiple
				  :limit="5"
				  :on-exceed="partner_files_handleFileExceed"
				  :file-list="partnerInfo_cols.files">
				  <el-button size="small" type="primary">点击上传</el-button>
				  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb
				  </div>
				</el-upload>
			  </el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeForm('modifyFormPartnerInfo')">关 闭</el-button>
				<el-button type="primary" @click="submitForm('modifyFormPartnerInfo')">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 员工信息登记 -->
		<el-dialog
		  title="员工信息登记"
		  ref="staffInfo"
		  class="mydialog"
		  :visible.sync="dialogVisibleStaffInfo"
		  :before-close="handleClose">
		  <!-- 员工用户的表单信息 -->
			<el-form ref="modifyFormStaffInfo" :inline="true" :rules="rules" :model="staffInfo_cols">
			  <el-form-item label="身份证号" prop='idcard'>
				<el-input v-model="staffInfo_cols.idcard" class="input-item" placeholder="请输入 ..."></el-input>
			  </el-form-item>
			  <el-form-item label="家庭住址" prop='address'>
				<el-input v-model="staffInfo_cols.address" class="input-item" placeholder="请输入 ..."></el-input>
			  </el-form-item>
			  <el-form-item label="部门/分公司" prop='cop'>
				<el-input v-model="staffInfo_cols.cop" class="input-item" placeholder="请输入 ..."></el-input>
			  </el-form-item>
			  <el-form-item label="办公地址" prop='cop_address'>
				<el-input v-model="staffInfo_cols.cop_address" class="input-item" placeholder="请输入 ..."></el-input>
			  </el-form-item>
			  <el-form-item label="身份证复印件" prop='idcard_files'>
				<el-upload
				  class="upload-demo"
				  :action="get_IOETOP_BaseUrl() + '/open/api/2.0.1/upload/file/' + get_username_at()"
				  :on-preview="staff_idcard_files_handleFilePreview"
				  :on-remove="staff_idcard_files_handleFileRemove"
				  :on-success="staff_idcard_files_handleFileSuccess"
				  :before-remove="staff_idcard_files_beforeFileRemove"
				  :before-upload="staff_idcard_files_beforeUpload"
				  multiple
				  :limit="5"
				  :on-exceed="staff_idcard_files_handleFileExceed"
				  :file-list="staffInfo_cols.idcard_files">
				  <el-button size="small" type="primary">点击上传</el-button>
				  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb
				  </div>
				</el-upload>
			  </el-form-item>
			  <el-form-item label="备注" prop='remark'>
				<el-input 
					v-model="staffInfo_cols.remark" 
					class="inputtextarea-item" 
					type="textarea"
					:rows="5"
					placeholder="请输入文字"></el-input>
			  </el-form-item>
			  <el-form-item label="附件" prop='files'>
				<el-upload
				  class="upload-demo"
				  :action="get_IOETOP_BaseUrl() + '/open/api/2.0.1/upload/file/' + get_username_at()"
				  :on-preview="staff_files_handleFilePreview"
				  :on-remove="staff_files_handleFileRemove"
				  :on-success="staff_files_handleFileSuccess"
				  :before-remove="staff_files_beforeFileRemove"
				  :before-upload="staff_files_beforeUpload"
				  multiple
				  :limit="5"
				  :on-exceed="staff_files_handleFileExceed"
				  :file-list="staffInfo_cols.files">
				  <el-button size="small" type="primary">点击上传</el-button>
				  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb
				  </div>
				</el-upload>
			  </el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeForm('modifyFormStaffInfo')">关 闭</el-button>
				<el-button type="primary" @click="submitForm('modifyFormStaffInfo')">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 联盟企业信息登记 -->
		<el-dialog
		  title="联盟企业信息登记"
		  ref="venderInfo"
		  class="mydialog"
		  :visible.sync="dialogVisibleVenderInfo"
		  :before-close="handleClose">
		  <!-- 联盟企业用户的表单信息 -->
			<el-form ref="modifyFormVenderInfo" :inline="true" :rules="rules" :model="venderInfo_cols">
			  <el-form-item label="统一社会信用代码" prop='idcard'>
				<el-input v-model="venderInfo_cols.idcard" class="input-item" placeholder="请输入 ..."></el-input>
			  </el-form-item>
			  <el-form-item label="注册地址" prop='address'>
				<el-input v-model="venderInfo_cols.address" class="input-item" placeholder="请输入 ..."></el-input>
			  </el-form-item>
			  <el-form-item label="公司名称" prop='cop'>
				<el-input v-model="venderInfo_cols.cop" class="input-item" placeholder="请输入 ..."></el-input>
			  </el-form-item>
			  <el-form-item label="办公地址" prop='cop_address'>
				<el-input v-model="venderInfo_cols.cop_address" class="input-item" placeholder="请输入 ..."></el-input>
			  </el-form-item>
			  <el-form-item label="营业执照" prop='idcard_files'>
				<el-upload
				  class="upload-demo"
				  :action="get_IOETOP_BaseUrl() + '/open/api/2.0.1/upload/file/' + get_username_at()"
				  :on-preview="vender_idcard_files_handleFilePreview"
				  :on-remove="vender_idcard_files_handleFileRemove"
				  :on-success="vender_idcard_files_handleFileSuccess"
				  :before-remove="vender_idcard_files_beforeFileRemove"
				  :before-upload="vender_idcard_files_beforeUpload"
				  multiple
				  :limit="5"
				  :on-exceed="vender_idcard_files_handleFileExceed"
				  :file-list="venderInfo_cols.idcard_files">
				  <el-button size="small" type="primary">点击上传</el-button>
				  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb
				  </div>
				</el-upload>
			  </el-form-item>
			  <el-form-item label="备注" prop='remark'>
				<el-input 
					v-model="venderInfo_cols.remark" 
					class="inputtextarea-item" 
					type="textarea"
					:rows="5"
					placeholder="请输入文字"></el-input>
			  </el-form-item>
			  <el-form-item label="附件" prop='files'>
				<el-upload
				  class="upload-demo"
				  :action="get_IOETOP_BaseUrl() + '/open/api/2.0.1/upload/file/' + get_username_at()"
				  :on-preview="vender_files_handleFilePreview"
				  :on-remove="vender_files_handleFileRemove"
				  :on-success="vender_files_handleFileSuccess"
				  :before-remove="vender_files_beforeFileRemove"
				  :before-upload="vender_files_beforeUpload"
				  multiple
				  :limit="5"
				  :on-exceed="vender_files_handleFileExceed"
				  :file-list="venderInfo_cols.files">
				  <el-button size="small" type="primary">点击上传</el-button>
				  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb
				  </div>
				</el-upload>
			  </el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeForm('modifyFormVenderInfo')">关 闭</el-button>
				<el-button type="primary" @click="submitForm('modifyFormVenderInfo')">确 定</el-button>
			</div>
		</el-dialog>
		
		<center>
		<div>
			<el-card v-if="userInfo.type === 'vender'" class="box-card">
			  <div slot="header" class="clearfix">
				<span><big>联盟企业信息管理</big></span>
				<el-button style="float: right; padding: 5px 15px" type="text"
					@click="handleUpdateInfo('vender')">修改</el-button>
			  </div>
			  <div class="table-container">
				<table style="width:100%" class="info-table">
				  <tr><td>身份证号</td><td>{{ venderInfo_cols.idcard }}</td></tr>
				  <tr><td>家庭住址</td><td>{{ venderInfo_cols.address }}</td></tr>
				  <tr><td>工作单位</td><td>{{ venderInfo_cols.cop }}</td></tr>
				  <tr><td>单位地址</td><td>{{ venderInfo_cols.cop_address }}</td></tr>
				  <tr><td>身份证复印件</td><td>
					    <template v-if="venderInfo_cols.idcard_files && venderInfo_cols.idcard_files.length">
						  <a v-for="(item, index) in venderInfo_cols.idcard_files" 
							:key="index"
							target="_blank" 
							:href="item.response.url"
							class="file-link">
							{{ item.response.name }}
							<span v-if="index < venderInfo_cols.idcard_files.length - 1">, </span>
						  </a>
						</template>
				  </td></tr>
				  <tr><td>备注信息</td><td>{{ venderInfo_cols.remark }}</td></tr>
				  <tr><td>附件</td><td>
					    <template v-if="venderInfo_cols.files && venderInfo_cols.files.length">
						  <a v-for="(item, index) in venderInfo_cols.files" 
							:key="index"
							target="_blank" 
							:href="item.response.url"
							class="file-link">
							{{ item.response.name }}
							<span v-if="index < venderInfo_cols.files.length - 1">, </span>
						  </a>
						</template>
				  </td></tr>
				</table>
			  </div>
			</el-card>
			<el-card v-else-if="userInfo.type === 'staff'" class="box-card">
			  <div slot="header" class="clearfix">
				<span><big>员工信息管理</big></span>
				<el-button style="float: right; padding: 5px 15px" type="text"
					@click="handleUpdateInfo('staff')">修改</el-button>
			  </div>
			  <div class="table-container">
				<table style="width:100%" class="info-table">
				  <tr><td>身份证号</td><td>{{ staffInfo_cols.idcard }}</td></tr>
				  <tr><td>家庭住址</td><td>{{ staffInfo_cols.address }}</td></tr>
				  <tr><td>工作单位</td><td>{{ staffInfo_cols.cop }}</td></tr>
				  <tr><td>单位地址</td><td>{{ staffInfo_cols.cop_address }}</td></tr>
				  <tr><td>身份证复印件</td><td>
					    <template v-if="staffInfo_cols.idcard_files && staffInfo_cols.idcard_files.length">
						  <a v-for="(item, index) in staffInfo_cols.idcard_files" 
							:key="index"
							target="_blank" 
							:href="item.response.url"
							class="file-link">
							{{ item.response.name }}
							<span v-if="index < staffInfo_cols.idcard_files.length - 1">, </span>
						  </a>
						</template>
				  </td></tr>
				  <tr><td>备注信息</td><td>{{ staffInfo_cols.remark }}</td></tr>
				  <tr><td>附件</td><td>
					    <template v-if="staffInfo_cols.files && staffInfo_cols.files.length">
						  <a v-for="(item, index) in staffInfo_cols.files" 
							:key="index"
							target="_blank" 
							:href="item.response.url"
							class="file-link">
							{{ item.response.name }}
							<span v-if="index < staffInfo_cols.files.length - 1">, </span>
						  </a>
						</template>
				  </td></tr>
				</table>
			  </div>
			</el-card>
			<el-card v-else-if="userInfo.type === 'partner'" class="box-card">
			  <div slot="header" class="clearfix">
				<span><big>合伙人信息管理</big></span>
				<el-button style="float: right; padding: 5px 15px" type="text"
					@click="handleUpdateInfo('partner')">修改</el-button>
			  </div>
			  <div class="table-container">
				<table style="width:100%" class="info-table">
				  <tr><td>身份证号</td><td>{{ partnerInfo_cols.idcard }}</td></tr>
				  <tr><td>家庭住址</td><td>{{ partnerInfo_cols.address }}</td></tr>
				  <tr><td>工作单位</td><td>{{ partnerInfo_cols.cop }}</td></tr>
				  <tr><td>单位地址</td><td>{{ partnerInfo_cols.cop_address }}</td></tr>
				  <tr><td>身份证复印件</td><td>
					    <template v-if="partnerInfo_cols.idcard_files && partnerInfo_cols.idcard_files.length">
						  <a v-for="(item, index) in partnerInfo_cols.idcard_files" 
							:key="index"
							target="_blank" 
							:href="item.response.url"
							class="file-link">
							{{ item.response.name }}
							<span v-if="index < partnerInfo_cols.idcard_files.length - 1">, </span>
						  </a>
						</template>
				  </td></tr>
				  <tr><td>备注信息</td><td>{{ partnerInfo_cols.remark }}</td></tr>
				  <tr><td>附件</td><td>
					    <template v-if="partnerInfo_cols.files && partnerInfo_cols.files.length">
						  <a v-for="(item, index) in partnerInfo_cols.files" 
							:key="index"
							target="_blank" 
							:href="item.response.url"
							class="file-link">
							<span v-if="item.response">{{ item.response.name }} </span>
							<span v-if="index < partnerInfo_cols.files.length - 1">, </span>
						  </a>
						</template>
				  </td></tr>
				  <tr><td colspan=2></td></tr>
				</table>
			  </div>
			</el-card>
			<el-card v-else class="box-card">
			  <div slot="header" class="clearfix">
				<span><big>信息管理</big></span>
				<el-button style="float: right; padding: 5px 15px" type="text"
					@click="handleUpdateInfo('other')">修改</el-button>
			  </div>
			  <div  class="table-container">
				<table style="width:100%" class="info-table">
				  <tr><td>身份证号</td><td>{{ otherInfo_cols.idcard }}</td></tr>
				  <tr><td>家庭住址</td><td>{{ otherInfo_cols.address }}</td></tr>
				  <tr><td>工作单位</td><td>{{ otherInfo_cols.cop }}</td></tr>
				  <tr><td>单位地址</td><td>{{ otherInfo_cols.cop_address }}</td></tr>
				  <tr><td>身份证复印件</td><td>
					    <template v-if="otherInfo_cols.idcard_files && otherInfo_cols.idcard_files.length">
						  <a v-for="(item, index) in otherInfo_cols.idcard_files" 
							:key="index"
							target="_blank" 
							:href="getDownloadURL(item.response,get_IOETOP_BaseUrl())"
							class="file-link">
							<span v-if="item.response">{{ item.response.name }} </span>
							<span v-if="index < otherInfo_cols.idcard_files.length - 1">, </span>
						  </a>
						</template>
				  </td></tr>
				  <tr><td>备注信息</td><td>{{ otherInfo_cols.remark }}</td></tr>
				  <tr><td>附件</td><td>
					    <template v-if="otherInfo_cols.files && otherInfo_cols.files.length">
						  <a v-for="(item, index) in otherInfo_cols.files" 
							:key="index"
							target="_blank" 
							:href="getDownloadURL(item.response,get_IOETOP_BaseUrl())"
							class="file-link">
							<span v-if="item.response">{{ item.response.name }} </span>
							<span v-if="index < otherInfo_cols.files.length - 1">, </span>
						  </a>
						</template>
				  </td></tr>
				</table>
			  </div>
			</el-card>
		</div>
		</center>
	</div>
</template>

<script>
import { getQuery, getDownloadURL } from '../api/'
export default {
	name: 'app-myinfo',
	data() { 
		return {
			// 用户信息
			userInfo: {},
			dialogVisibleUploading: false,
			fileOnUploading: false,
			filesOnUploading: [],
			// 默认用户信息表
			defaultInfo_cols: {
				idcard: "",
				address: "",
				cop: "",
				cop_address: "",
				remark: "",
				files: [],
				idcard_files: [],
			},
			// 登记信息表
			otherInfo_cols: {
				idcard: "",
				address: "",
				cop: "",
				cop_address: "",
				remark: "",
				files: [],
				idcard_files: [],
			},
			// 合伙人用户信息表
			partnerInfo_cols: {
				idcard: "",
				address: "",
				cop: "",
				cop_address: "",
				remark: "",
				files: [],
				idcard_files: [],
			},
			// 员工用户信息表
			staffInfo_cols: {
				idcard: "",
				address: "",
				cop: "",
				cop_address: "",
				remark: "",
				files: [],
				idcard_files: [],
			},
			// 联盟企业用户信息表
			venderInfo_cols: {
				idcard: "",
				address: "",
				cop: "",
				cop_address: "",
				remark: "",
				files: [],
				idcard_files: [],
			},
			// 补充信息登记 form 元素
			dialogVisibleOtherInfo: false,
			dialogVisibleStaffInfo: false,
			dialogVisiblePartnerInfo: false,
			dialogVisibleVenderInfo: false,
			dialogUserInfoActive: true,
			// 校验规则
			rules: {
				username: [
					{ required: true, message: "请选择菜单显示设置，不可以为空！", trigger: 'blur'},
					{ min: 4, max: 48, message: "长度必须为 4 到 40个字符！", trigger: 'blur'},
				],
				realname: [
					{ required: true, message: "请选择图标设置，不可以为空！", trigger: 'blur'},
					{ min: 4, max: 48, message: "长度必须为 4 到 40个字符！", trigger: 'blur'},
				],
				password: [
					{ required: true, message: "请输入密码，不可以为空！", trigger: 'blur'},
					{ min: 6, max: 30, message: "长度必须为 6 到 30个字符！", trigger: 'blur'},
				],
				accesscode: [
					{ min: 32, max: 128, message: "长度必须为 32 到 128个字符！", trigger: 'blur'},
				],
				tel1: [
					{ min: 6, max: 15, message: "长度必须为 6 到 15个字符！", trigger: 'blur'},
				],
				tel2: [
				],
			},
	}},
	state: {
	},
	mounted() {
		this.get_myInfo();
	},
	methods: {
		// 获得IOETOP业务服务器
		get_IOETOP_BaseUrl()
		{
			return this.$utils.getBaseUrl(true,false,false,3);
		},
		// 文件下载组件
		getDownloadURL(url,domainname = null) {
			return getDownloadURL(url,domainname);
		},
		// 获得当前用户信息
		get_myInfo() {
			let params = {};
			let jres = getQuery("sys_users_my","get",params);
			if(jres.code === 20000)
			{
				this.userInfo = jres.list;
				if(jres.list.type === "vender") {
					this.venderInfo_cols = jres.list.info;
				} else if(jres.list.type === "staff") {
					this.staffInfo_cols = jres.list.info;
				} else if(jres.list.type === "partner") {
					this.partnerInfo_cols = jres.list.info;
				} else {
					this.otherInfo_cols = jres.list.info;
				}
			}
			else
			{
				this.$message({
					type: 'error',
					message: '用户未注册，请先注册！'
				}); 
			}
		},
		// 信息登记
		handleUpdateInfo(type) {
			// 员工信息登记
			if(type === "staff") {
				if(!this.staffInfo_cols 
					|| typeof(this.staffInfo_cols)!="object")
				{
					this.staffInfo_cols = {
						idcard: "",
						address: "",
						cop: "",
						cop_address: "",
						remark: "",
						files: [],
						idcard_files: [],
					};
				}
				
				this.modalType = 1;
				this.dialogVisibleStaffInfo = true;
			}
			// 合伙人信息登记
			else if(type === "partner") {
				if(!this.partnerInfo_cols 
					|| typeof(this.partnerInfo_cols)!="object")
				{
					this.partnerInfo_cols = {
						idcard: "",
						address: "",
						cop: "",
						cop_address: "",
						remark: "",
						files: [],
						idcard_files: [],
					};
				}
				
				this.modalType = 1;
				this.dialogVisiblePartnerInfo = true;
			}
			// 联盟企业信息登记
			else if(type === "vender") {
				if(!this.venderInfo_cols 
					|| typeof(this.venderInfo_cols)!="object")
				{
					this.venderInfo_cols = {
						idcard: "",
						address: "",
						cop: "",
						cop_address: "",
						remark: "",
						files: [],
						idcard_files: [],
					};
				}
				
				this.modalType = 1;
				this.dialogVisibleVenderInfo = true;
			}
			// 信息登记
			else {
				if(!this.otherInfo_cols 
					|| typeof(this.otherInfo_cols)!="object")
				{
					this.otherInfo_cols = {
						idcard: "",
						address: "",
						cop: "",
						cop_address: "",
						remark: "",
						files: [],
						idcard_files: [],
					};
				}
				
				this.modalType = 1;
				this.dialogVisibleOtherInfo = true;
			}
		},
		// 检测设备类型
		checkIsMobile() {
			this.isMobile = window.innerWidth <= 768;
			window.addEventListener('resize', () => {
				this.isMobile = window.innerWidth <= 768;
			});
		},
		get_username_at() {
			// 验证登陆状态
			let u = this.$utils.fun_is_online();
			let ua = 'u/' + u.username + "/a/" + u.at;
			//console.log(ua);
			return ua;
		},
		gethttporhttps() {
			return window.location.protocol;
		},
		// 关闭按钮触发
		handleClose(done) {
			this.$confirm('确认关闭？')
			.then(_ => {
				this.closeForm("");
				done();
			})
			.catch(_ => {});
		},
		Uploading_handleClose (done) {
			this.dialogVisibleUploading = false;
			this.filesOnUploading = []; 
		},
		// 关闭添加窗口操作
		closeForm(formName) {
			this.dialogVisibleOtherInfo = false;
			this.dialogVisibleStaffInfo = false,
			this.dialogVisiblePartnerInfo = false,
			this.dialogVisibleVenderInfo = false,
			this.$refs[formName].resetFields();
			this.resetFormData();
		},
		// 提交按钮
		submitForm(formName) {
			//console.log("formName:",formName);
			this.$refs[formName].validate((valid) => {
				// 提交校验正确
				if (valid) {
					if(formName === 'modifyFormOtherInfo')
					{
						let params = {};
						//params.col = "id";
						//params.id = this.formUserInfo_cols.id;
						//params.cols = this.formUserInfo_cols;
						params.cols = {};
						params.cols.info = {};
						params.cols.info = this.otherInfo_cols;
						//if(this.fileList) if(this.fileList.length>0) params.cols.files = this.fileList;
						delete params.cols.id;
						let jres = getQuery("sys_users_my","update",params);
						//console.log("params:",params);
						
						if(jres)
						{
							this.$message({
								type: 'success',
								message: '信息登记成功！'
							});  
						
							const thisobj = this;
							setTimeout(function() {
								thisobj.get_myInfo();
							},100);
						}
						else
						{
							this.$message({
								type: 'error',
								message: '信息登记失败！'
							});  
						}
					}
					else if(formName === 'modifyFormPartnerInfo')
					{
						let params = {};
						//params.col = "id";
						//params.id = this.formUserInfo_cols.id;
						//params.cols = this.formUserInfo_cols;
						params.cols = {};
						params.cols.info = {};
						params.cols.info = this.partnerInfo_cols;
						//if(this.fileList) if(this.fileList.length>0) params.cols.files = this.fileList;
						delete params.cols.id;
						let jres = getQuery("sys_users_my","update",params);
						//console.log("params:",params);
						
						if(jres)
						{
							this.$message({
								type: 'success',
								message: '信息登记成功！'
							});  
						
							const thisobj = this;
							setTimeout(function() {
								thisobj.get_myInfo();
							},100);
						}
						else
						{
							this.$message({
								type: 'error',
								message: '信息登记失败！'
							});  
						}
					}
					else if(formName === 'modifyFormStaffInfo')
					{
						let params = {};
						//params.col = "id";
						//params.id = this.formUserInfo_cols.id;
						//params.cols = this.formUserInfo_cols;
						params.cols = {};
						params.cols.info = {};
						params.cols.info = this.staffInfo_cols;
						//if(this.fileList) if(this.fileList.length>0) params.cols.files = this.fileList;
						delete params.cols.id;
						let jres = getQuery("sys_users_my","update",params);
						//console.log("params:",params);
						
						if(jres)
						{
							this.$message({
								type: 'success',
								message: '信息登记成功！'
							});  
						
							const thisobj = this;
							setTimeout(function() {
								thisobj.get_myInfo();
							},100);
						}
						else
						{
							this.$message({
								type: 'error',
								message: '信息登记失败！'
							});  
						}
					}
					else if(formName === 'modifyFormVenderInfo')
					{
						let params = {};
						//params.col = "id";
						//params.id = this.formUserInfo_cols.id;
						//params.cols = this.formUserInfo_cols;
						params.cols = {};
						params.cols.info = {};
						params.cols.info = this.venderInfo_cols;
						//if(this.fileList) if(this.fileList.length>0) params.cols.files = this.fileList;
						delete params.cols.id;
						let jres = getQuery("sys_users_my","update",params);
						//console.log("params:",params);
						
						if(jres)
						{
							this.$message({
								type: 'success',
								message: '信息登记成功！'
							});  
						
							const thisobj = this;
							setTimeout(function() {
								thisobj.get_myInfo();
							},100);
						}
						else
						{
							this.$message({
								type: 'error',
								message: '信息登记失败！'
							});  
						}
					}
					else 
					{
						this.$message({
							type: 'error',
							message: '提交信息失败！'
						}); 
					} 
					
					this.closeForm(formName);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 重置按钮
		resetForm(formName) {
			this.$refs[formName].resetFields();
			//this.resetFormData();
		},
		// 重置表单数据
		resetFormData() {
		},
		get_filelist(list) {
			let res = "";
			list.forEach(item => {
				res = res + 
					"<a target=_blank href='" + item.response.url +"'>" + 
						item.response.name + 
					"</a>";
			});
			return res;
		},
		// 附加信息附件管理
		other_idcard_files_handleFileRemove(file, fileList) {
			this.otherInfo_cols.idcard_files = fileList;
		},
		other_idcard_files_handleFilePreview(file) {
		},
		other_idcard_files_handleFileExceed(files, fileList) {
			this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
		},
		other_idcard_files_handleFileSuccess(response, file, fileList) {
			//this.dialogVisibleUploading = false;
			
			this.filesOnUploading = this.filesOnUploading.filter(item => item.name !== file.name);
			if(this.filesOnUploading.length == 0) this.dialogVisibleUploading = false;
			
			let itemfiles = [];
			if (response.code === 20000) {
				fileList.forEach( item => {
					let itemfile = {};
					if(item.response && item.raw)
					{
						itemfile.name = item.response.name;
						itemfile.filepath = item.response.filepath;
						itemfile.url = item.response.url;
						itemfile.size = item.raw.size;
						itemfile.type = item.raw.type;
						itemfile.lastModified = item.raw.lastModified;
						itemfiles.push(itemfile);
					}
					else console.log("item:", item);
				});
				this.otherInfo_cols.idcard_files = fileList;
			}
			else
			{
			}
		},
		other_idcard_files_beforeFileRemove(file, fileList) {
			//return this.$confirm(`确定移除 ${ file.name }？`);
		},
		// 文件上传前的验证
		other_idcard_files_beforeUpload(file) {
			// 限制文件大小：500KB = 500 * 1024 bytes
			const isLt500K = file.size / 1024 / 1024 < 200;

			if (!isLt500K) {
				this.$message.error('上传文件大小不能超过 200MB!');
				return false; // 阻止上传
			}
			this.fileOnUploading = file;
			this.dialogVisibleUploading = true;
			this.filesOnUploading.push(file);
			return true; // 允许上传
		},
		other_files_handleFileRemove(file, fileList) {
			this.otherInfo_cols.files = fileList;
		},
		other_files_handleFilePreview(file) {
		},
		other_files_handleFileExceed(files, fileList) {
			this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
		},
		other_files_handleFileSuccess(response, file, fileList) {
			//this.dialogVisibleUploading = false;
			
			this.filesOnUploading = this.filesOnUploading.filter(item => item.name !== file.name);
			if(this.filesOnUploading.length == 0) this.dialogVisibleUploading = false;
			
			let itemfiles = [];
			if (response.code === 20000) {
				fileList.forEach( item => {
					let itemfile = {};
					if(item.response && item.raw)
					{
						itemfile.name = item.response.name;
						itemfile.filepath = item.response.filepath;
						itemfile.url = item.response.url;
						itemfile.size = item.raw.size;
						itemfile.type = item.raw.type;
						itemfile.lastModified = item.raw.lastModified;
						itemfiles.push(itemfile);
					}
					else console.log("item:", item);
				});
				this.otherInfo_cols.files = fileList;
			}
			else
			{
			}
		},
		other_files_beforeFileRemove(file, fileList) {
			//return this.$confirm(`确定移除 ${ file.name }？`);
		},
		// 文件上传前的验证
		other_files_beforeUpload(file) {
			// 限制文件大小：500KB = 500 * 1024 bytes
			const isLt500K = file.size / 1024 / 1024 < 200;

			if (!isLt500K) {
				this.$message.error('上传文件大小不能超过 200MB!');
				return false; // 阻止上传
			}
			this.fileOnUploading = file;
			this.dialogVisibleUploading = true;
			this.filesOnUploading.push(file);
			return true; // 允许上传
		},
		// 合伙人信息附件管理
		partner_idcard_files_handleFileRemove(file, fileList) {
			this.partnerInfo_cols.idcard_files = fileList;
		},
		partner_idcard_files_handleFilePreview(file) {
		},
		partner_idcard_files_handleFileExceed(files, fileList) {
			this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
		},
		partner_idcard_files_handleFileSuccess(response, file, fileList) {
			//this.dialogVisibleUploading = false;
			
			this.filesOnUploading = this.filesOnUploading.filter(item => item.name !== file.name);
			if(this.filesOnUploading.length == 0) this.dialogVisibleUploading = false;
			
			let itemfiles = [];
			if (response.code === 20000) {
				fileList.forEach( item => {
					let itemfile = {};
					if(item.response && item.raw)
					{
						itemfile.name = item.response.name;
						itemfile.filepath = item.response.filepath;
						itemfile.url = item.response.url;
						itemfile.size = item.raw.size;
						itemfile.type = item.raw.type;
						itemfile.lastModified = item.raw.lastModified;
						itemfiles.push(itemfile);
					}
					else console.log("item:", item);
				});
				this.partnerInfo_cols.idcard_files = fileList;
			}
			else
			{
			}
		},
		partner_idcard_files_beforeFileRemove(file, fileList) {
			//return this.$confirm(`确定移除 ${ file.name }？`);
		},
		// 文件上传前的验证
		partner_idcard_files_beforeUpload(file) {
			// 限制文件大小：500KB = 500 * 1024 bytes
			const isLt500K = file.size / 1024 / 1024 < 200;

			if (!isLt500K) {
				this.$message.error('上传文件大小不能超过 200MB!');
				return false; // 阻止上传
			}
			this.fileOnUploading = file;
			this.dialogVisibleUploading = true;
			this.filesOnUploading.push(file);
			return true; // 允许上传
		},
		partner_files_handleFileRemove(file, fileList) {
			this.partnerInfo_cols.files = fileList;
		},
		partner_files_handleFilePreview(file) {
		},
		partner_files_handleFileExceed(files, fileList) {
			this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
		},
		partner_files_handleFileSuccess(response, file, fileList) {
			//this.dialogVisibleUploading = false;
			
			this.filesOnUploading = this.filesOnUploading.filter(item => item.name !== file.name);
			if(this.filesOnUploading.length == 0) this.dialogVisibleUploading = false;
			
			let itemfiles = [];
			if (response.code === 20000) {
				fileList.forEach( item => {
					let itemfile = {};
					if(item.response && item.raw)
					{
						itemfile.name = item.response.name;
						itemfile.filepath = item.response.filepath;
						itemfile.url = item.response.url;
						itemfile.size = item.raw.size;
						itemfile.type = item.raw.type;
						itemfile.lastModified = item.raw.lastModified;
						itemfiles.push(itemfile);
					}
					else console.log("item:", item);
				});
				this.partnerInfo_cols.files = fileList;
			}
			else
			{
			}
		},
		partner_files_beforeFileRemove(file, fileList) {
			//return this.$confirm(`确定移除 ${ file.name }？`);
		},
		// 文件上传前的验证
		partner_files_beforeUpload(file) {
			// 限制文件大小：500KB = 500 * 1024 bytes
			const isLt500K = file.size / 1024 / 1024 < 200;

			if (!isLt500K) {
				this.$message.error('上传文件大小不能超过 200MB!');
				return false; // 阻止上传
			}
			this.fileOnUploading = file;
			this.dialogVisibleUploading = true;
			this.filesOnUploading.push(file);
			return true; // 允许上传
		},
		// 联盟企业信息附件管理
		vender_idcard_files_handleFileRemove(file, fileList) {
			this.venderInfo_cols.idcard_files = fileList;
		},
		vender_idcard_files_handleFilePreview(file) {
		},
		vender_idcard_files_handleFileExceed(files, fileList) {
			this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
		},
		vender_idcard_files_handleFileSuccess(response, file, fileList) {
			//this.dialogVisibleUploading = false;
			
			this.filesOnUploading = this.filesOnUploading.filter(item => item.name !== file.name);
			if(this.filesOnUploading.length == 0) this.dialogVisibleUploading = false;
			
			let itemfiles = [];
			if (response.code === 20000) {
				fileList.forEach( item => {
					let itemfile = {};
					if(item.response && item.raw)
					{
						itemfile.name = item.response.name;
						itemfile.filepath = item.response.filepath;
						itemfile.url = item.response.url;
						itemfile.size = item.raw.size;
						itemfile.type = item.raw.type;
						itemfile.lastModified = item.raw.lastModified;
						itemfiles.push(itemfile);
					}
					else console.log("item:", item);
				});
				this.venderInfo_cols.idcard_files = fileList;
			}
			else
			{
			}
		},
		vender_idcard_files_beforeFileRemove(file, fileList) {
			//return this.$confirm(`确定移除 ${ file.name }？`);
		},
		// 文件上传前的验证
		vender_idcard_files_beforeUpload(file) {
			// 限制文件大小：500KB = 500 * 1024 bytes
			const isLt500K = file.size / 1024 / 1024 < 200;

			if (!isLt500K) {
				this.$message.error('上传文件大小不能超过 200MB!');
				return false; // 阻止上传
			}
			this.fileOnUploading = file;
			this.dialogVisibleUploading = true;
			this.filesOnUploading.push(file);
			return true; // 允许上传
		},
		vender_files_handleFileRemove(file, fileList) {
			this.venderInfo_cols.files = fileList;
		},
		vender_files_handleFilePreview(file) {
		},
		vender_files_handleFileExceed(files, fileList) {
			this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
		},
		vender_files_handleFileSuccess(response, file, fileList) {
			//this.dialogVisibleUploading = false;
			
			this.filesOnUploading = this.filesOnUploading.filter(item => item.name !== file.name);
			if(this.filesOnUploading.length == 0) this.dialogVisibleUploading = false;
			
			let itemfiles = [];
			if (response.code === 20000) {
				fileList.forEach( item => {
					let itemfile = {};
					if(item.response && item.raw)
					{
						itemfile.name = item.response.name;
						itemfile.filepath = item.response.filepath;
						itemfile.url = item.response.url;
						itemfile.size = item.raw.size;
						itemfile.type = item.raw.type;
						itemfile.lastModified = item.raw.lastModified;
						itemfiles.push(itemfile);
					}
					else console.log("item:", item);
				});
				this.venderInfo_cols.files = fileList;
			}
			else
			{
			}
		},
		vender_files_beforeFileRemove(file, fileList) {
			//return this.$confirm(`确定移除 ${ file.name }？`);
		},
		// 文件上传前的验证
		vender_files_beforeUpload(file) {
			// 限制文件大小：500KB = 500 * 1024 bytes
			const isLt500K = file.size / 1024 / 1024 < 200;

			if (!isLt500K) {
				this.$message.error('上传文件大小不能超过 200MB!');
				return false; // 阻止上传
			}
			this.fileOnUploading = file;
			this.dialogVisibleUploading = true;
			this.filesOnUploading.push(file);
			return true; // 允许上传
		},
		// 员工信息附件管理
		staff_idcard_files_handleFileRemove(file, fileList) {
			this.staffInfo_cols.idcard_files = fileList;
		},
		staff_idcard_files_handleFilePreview(file) {
		},
		staff_idcard_files_handleFileExceed(files, fileList) {
			this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
		},
		staff_idcard_files_handleFileSuccess(response, file, fileList) {
			//this.dialogVisibleUploading = false;
			
			this.filesOnUploading = this.filesOnUploading.filter(item => item.name !== file.name);
			if(this.filesOnUploading.length == 0) this.dialogVisibleUploading = false;
			
			let itemfiles = [];
			if (response.code === 20000) {
				fileList.forEach( item => {
					let itemfile = {};
					if(item.response && item.raw)
					{
						itemfile.name = item.response.name;
						itemfile.filepath = item.response.filepath;
						itemfile.url = item.response.url;
						itemfile.size = item.raw.size;
						itemfile.type = item.raw.type;
						itemfile.lastModified = item.raw.lastModified;
						itemfiles.push(itemfile);
					}
					else console.log("item:", item);
				});
				this.staffInfo_cols.idcard_files = fileList;
			}
			else
			{
			}
		},
		staff_idcard_files_beforeFileRemove(file, fileList) {
			//return this.$confirm(`确定移除 ${ file.name }？`);
		},
		// 文件上传前的验证
		staff_idcard_files_beforeUpload(file) {
			// 限制文件大小：500KB = 500 * 1024 bytes
			const isLt500K = file.size / 1024 / 1024 < 200;

			if (!isLt500K) {
				this.$message.error('上传文件大小不能超过 200MB!');
				return false; // 阻止上传
			}
			this.fileOnUploading = file;
			this.dialogVisibleUploading = true;
			this.filesOnUploading.push(file);
			return true; // 允许上传
		},
		staff_files_handleFileRemove(file, fileList) {
			this.staffInfo_cols.files = fileList;
		},
		staff_files_handleFilePreview(file) {
		},
		staff_files_handleFileExceed(files, fileList) {
			this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
		},
		staff_files_handleFileSuccess(response, file, fileList) {
			//this.dialogVisibleUploading = false;
			
			this.filesOnUploading = this.filesOnUploading.filter(item => item.name !== file.name);
			if(this.filesOnUploading.length == 0) this.dialogVisibleUploading = false;
			
			if (response.code === 20000) {
				this.staffInfo_cols.files = fileList;
			}
			else
			{
			}
		},
		staff_files_beforeFileRemove(file, fileList) {
			//return this.$confirm(`确定移除 ${ file.name }？`);
		},
		// 文件上传前的验证
		staff_files_beforeUpload(file) {
			// 限制文件大小：500KB = 500 * 1024 bytes
			const isLt500K = file.size / 1024 / 1024 < 200;

			if (!isLt500K) {
				this.$message.error('上传文件大小不能超过 200MB!');
				return false; // 阻止上传
			}
			this.fileOnUploading = file;
			this.dialogVisibleUploading = true;
			this.filesOnUploading.push(file);
			return true; // 允许上传
		},
	},
	computed: {
	},
	mutations: {
	}
}
</script>

<style lang="less" Scoped>
.app-myinfo {
  padding: 5px;

  // 卡片样式
  .box-card {
    width: calc(100% -10px);
    max-width: 480px;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border: 1px solid #f0f0f0;
    transition: all 0.3s ease;
    margin: 0 auto;

    &:hover {
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
      transform: translateY(-2px);
    }

    .el-card__header {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      padding: 16px 20px;
      border-radius: 12px 12px 0 0;

      .clearfix {
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
          color: white;
          font-size: 16px;
          font-weight: 600;
        }

        .el-button {
          color: white;
          padding: 6px 12px;
          border-radius: 6px;
          background: rgba(255, 255, 255, 0.2);
          border: 1px solid rgba(255, 255, 255, 0.3);
          transition: all 0.3s ease;

          &:hover {
            background: rgba(255, 255, 255, 0.3);
            transform: translateY(-1px);
          }
        }
      }
    }

    .el-card__body {
      padding: 0;
    }
  }

  // 表格容器
  .table-container {
    padding: 16px;
  }

  // 信息表格
  .info-table {
    width: 100%;
    border-collapse: collapse;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

    tr {
      transition: background-color 0.3s ease;

      &:nth-child(even) {
        background: #f8f9fa;
      }

      &:hover {
        background: #f0f7ff;
      }
    }

    td {
      padding: 16px 20px;
      border-bottom: 1px solid #eaeaea;
      font-size: 14px;
      line-height: 1.6;
      vertical-align: top;

      &:first-child {
        width: 200px;
        text-align: left;
        font-weight: 600;
        color: #2c3e50;
        background-color: #f8f9fa;
        border-left: 2px solid #409EFF;
      }

      &:last-child {
        color: #606266;
        word-break: break-word;
      }
    }

    // 文件链接样式
    .file-link {
      display: inline-flex;
      align-items: center;
      padding: 4px 8px;
      margin: 2px 4px 2px 0;
      background: #f0f7ff;
      color: #409EFF;
      text-decoration: none;
      border-radius: 4px;
      font-size: 12px;
      transition: all 0.3s ease;
      border: 1px solid #e1f3ff;

      &:hover {
        background: #409EFF;
        color: white;
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
      }
    }
  }

  // 对话框样式
  .mydialog {
    .el-dialog {
      border-radius: 16px;
      overflow: hidden;

      .el-dialog__header {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        padding: 16px 20px;

        .el-dialog__title {
          color: white;
          font-size: 18px;
          font-weight: 600;
        }

        .el-dialog__headerbtn {
          top: 16px;

          .el-dialog__close {
            color: white;
            font-size: 18px;
          }
        }
      }

      .el-dialog__body {
        padding: 20px;
        max-height: 70vh;
        overflow-y: auto;
      }
    }

    // 表单样式
    .el-form {
      .el-form-item {
        width: 100%;
        margin-bottom: 20px;
		display: flex;

        .el-form-item__label {
          font-weight: 600;
          color: #303133;
          margin-bottom: 8px;
          display: block;
		  width: 110px;
		  text-align:right;
        }

        .input-item,
        .inputtextarea-item {
          width: 100%;

          .el-input__inner,
          .el-textarea__inner {
            border-radius: 8px;
            border: 1px solid #e6e6e6;
            transition: all 0.3s ease;
            padding: 12px 16px;

            &:focus {
              border-color: #409EFF;
              box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
            }
          }
        }

        // 上传组件样式
        .upload-demo {
          .el-upload {
            .el-button {
              background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
              border: none;
              border-radius: 6px;
              padding: 10px 20px;
              transition: all 0.3s ease;

              &:hover {
                transform: translateY(-1px);
                box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
              }
            }
          }

          .el-upload__tip {
            margin-top: 8px;
            color: #909399;
            font-size: 12px;
          }

          .el-upload-list {
            .el-upload-list__item {
              transition: all 0.3s ease;
              border-radius: 6px;
              margin-top: 8px;

              &:hover {
                background: #f5f7fa;
              }

              .el-icon-close {
                color: #F56C6C;

                &:hover {
                  color: #f78989;
                }
              }
            }
          }
        }
      }
    }

    
    .dialog-footer {
      display: flex;
	  justify-content: flex-end; 
      gap: 12px;
      padding: 0px;
      padding-top: 15px;
      background: #f8f9fa;
      border-top: 1px solid #e9ecef;

		.el-button {
			width: 50%;
			max-width: 135px;
		}
      
      .action-btn {
        flex: 1;
        padding: 12px 20px;
        border-radius: 8px;
        font-weight: 500;
        
        &.recommend-btn {
          background: linear-gradient(45deg, #67C23A, #85ce61);
          color: white;
          border: none;
        }
        
        &.pause-btn {
          background: linear-gradient(45deg, #E6A23C, #ebb563);
          color: white;
          border: none;
        }
        
        &.close-btn {
          background: white;
          color: #606266;
          border: 1px solid #dcdfe6;
        }
      }
    }
  }

  // 上传中对话框
  .el-dialog__wrapper:first-child {
    .el-dialog {
      border-radius: 12px;

      .el-dialog__body {
        padding: 20px;

        div {
          display: flex;
          align-items: center;
          padding: 12px;
          background: #f8f9fa;
          border-radius: 8px;
          margin-bottom: 8px;
          transition: all 0.3s ease;

          &:last-child {
            margin-bottom: 0;
          }

          .el-icon-loading {
            color: #409EFF;
            font-size: 16px;
          }

          span[style*="font-weight:bold"] {
            color: #303133;
            flex: 1;
          }

          span[style*="color:#d0d0d0"] {
            font-size: 12px;
          }
        }
      }
    }
  }

  // 响应式调整
  @media (max-width: 768px) {
    padding: 0px;

    .box-card {
      max-width: none;

      .el-card__header {
        padding: 12px 16px;

        .clearfix {
          span {
            font-size: 15px;
          }
        }
      }
    }

    .table-container {
      padding: 12px;
    }

    .info-table {
      td {
        padding: 12px 15px;
        font-size: 13px;

        &:first-child {
          width: 100px;
          padding: 10px 12px;
          font-size: 12px;
        }
      }
    }

    .mydialog {
      .el-dialog {
        width: 95% !important;

        .el-dialog__body {
          padding: 16px;
          max-height: 100%;
		  height: auto;
        }
      }

      .el-form {
        .el-form-item {
		
          .el-form-item__label {
			text-align:left;
			margin-bottom:0px;
			padding-bottom: 0px;
			line-height: 30px;
          }
          margin-bottom: 16px;

          .input-item,
          .inputtextarea-item {
            .el-input__inner,
            .el-textarea__inner {
              padding: 10px 14px;
              font-size: 14px;
            }
          }
        }
      }
    }

    // 移动端文件链接调整
    .file-link {
      font-size: 11px;
      padding: 3px 6px;
      margin: 1px 2px 1px 0;
    }
  }

  // 暗色模式支持
  @media (prefers-color-scheme: dark) {
    .box-card {
      background: #2d3748;
      border-color: #4a5568;

      .el-card__header {
        background: linear-gradient(135deg, #2d3748 0%, #4a5568 100%);
      }

      .info-table {
        tr {
          &:nth-child(even) {
            background: #4a5568;
          }

          &:hover {
            background: #2d3748;
          }
        }

        td {
          border-bottom-color: #4a5568;
          color: #e2e8f0;

          &:first-child {
            background: #4a5568;
            color: #e2e8f0;
            border-right-color: #409EFF;
          }
        }
      }
    }

    .mydialog {
      .el-dialog {
        background: #2d3748;

        .el-dialog__header {
          background: linear-gradient(135deg, #2d3748 0%, #4a5568 100%);
        }

        .el-form {
          .el-form-item__label {
            color: #e2e8f0;
			text-align:left;
          }

          .input-item,
          .inputtextarea-item {
            .el-input__inner,
            .el-textarea__inner {
              background: #4a5568;
              border-color: #4a5568;
              color: #e2e8f0;

              &:focus {
                border-color: #409EFF;
              }
            }
          }
        }
      }
    }

    // 文件链接暗色模式
    .file-link {
      background: #4a5568;
      border-color: #4a5568;
      color: #409EFF;
    }
  }
}
</style>